export const forms = {
	validation: {
		required: "{{field}} er påkrevd",
		min: "{{field}} må være minst {{min}} tegn",
		max: "{{field}} kan være maksimalt {{max}} tegn",
		invalid: "{{field}} er ikke gyldig",
		lowercase: "{{field}} må inneholde minst én liten bokstav",
		uppercase: "{{field}} må inneholde minst én stor bokstav",
		number: "{{field}} må inneholde minst ett tall",
		special_character: "{{field}} må inneholde minst ett spesialtegn",
	},
	email: {
		label: "E-post",
		placeholder: "Skriv inn e-post",
	},
	password: {
		label: "Passord",
		placeholder: "you@example.no",
		password_match: "Passordene må være like",
	},
	first_name: {
		label: "Fornavn",
		placeholder: "John",
	},
	last_name: {
		label: "Etternavn",
		placeholder: "Doe",
	},
};
